import { vec3 } from 'gl-matrix';
import { colyseusObj } from './colyseus';
export let spawnPointContainer;

const TOO_CLOSE_RADIUS = 6;

WL.registerComponent('spawn-point-container', {
}, {
  init: function () {
    spawnPointContainer = this;
    window.sp = this;
    this.children = this.object.children;
    this.playerPositions = [];
    this.spawnPositions = [];
    for (let i = 0; i < this.children.length; i++) {
      const child = this.children[i];
      // Store spawn point position in array for faster calculations
      let childPosition = vec3.create();
      child.getTranslationWorld(childPosition);
      this.spawnPositions.push(childPosition);

      // Disable visualisation meshes
      const mesh = child.getComponent('mesh');
      mesh.active = false;
    }

  },
  getBestSpawnPoint: function () {
    const players = Array.from(colyseusObj.players.values());
    for (let i = 0; i < players.length; i++) {
      const player = players[i].object;
      if(!this.playerPositions[i]) this.playerPositions.push(vec3.create());
      player.getTranslationWorld(this.playerPositions[i]);
    }

    shuffle(this.spawnPositions);
    
    let totalDistances = [];
    for (let i = 0; i < this.spawnPositions.length; i++) {
      const spawnPosition = this.spawnPositions[i];
      totalDistances.push(0)
      for (let j = 0; j < this.playerPositions.length; j++) {
        const playerPosition = this.playerPositions[j];
        let dist = vec3.dist(playerPosition, spawnPosition);
        if(dist < TOO_CLOSE_RADIUS) {
          // TODO: skip considering dead players
          totalDistances[i] = 100000000;
          break;
        } else {
          found = true;
        }
      }
    }

    return this.spawnPositions[totalDistances.indexOf(Math.min(...totalDistances))]
  }
});

function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}